/**
 * Legacy entry point for `NavigationService`.
 *
 * The real implementation now lives at:
 *   apps/b2b-frontend/app/core/navigation/navigation.service.ts
 *
 * Registered with AngularJS in
 *   apps/b2b-frontend/app/upgrade/ng-downgraded-components.ts
 * via downgradeInjectable, so any `$inject = ['NavigationService']` resolves
 * to the Angular 18 class. The `acme.common.service.navigation` AngularJS
 * module is kept (empty) so existing module dependency arrays keep resolving.
 */
import angular from 'angular';

export { NavigationService } from '@ng/core/navigation/navigation.service';
export type {
  NavigationEngine,
  NavigationItem,
  NavigationItems,
  NavigationSecurity,
} from '@ng/core/navigation/navigation.service';

export const NavigationServiceModule = angular.module('acme.common.service.navigation', [
  'acme.common.service.auth',
]).name;
